export enum AttachmentType {
  PHOTO = 'photo',
  VIDEO = 'video_inline',
  ALBUM = 'album',
  PROFILE_MEDIA = 'profile_media',
  SHARE = 'share',
  COVER_PHOTO = 'cover_photo',
  STICKER = 'sticker'
}
